import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "@/lib/utils";
import { Icon, Typography } from "@bookips/sds";
import { memo } from "react";
export const IpSelectFilter = /*#__PURE__*/ memo((param)=>{
    let { label , selectedLabel , options , isOpen , selectedIndex , onToggle , onSelect , onClose , disabled , className  } = param;
    const displayLabel = selectedLabel || label;
    const handleToggle = ()=>{
        if (disabled) return;
        onToggle();
    };
    const handleSelect = (index)=>{
        onSelect(index);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "relative",
        children: [
            /*#__PURE__*/ _jsxs("button", {
                type: "button",
                onClick: handleToggle,
                disabled: disabled,
                className: cn("flex items-center gap-1.5 px-3 py-2.5 rounded-md border border-gray-200 bg-white", "hover:border-gray-300 transition-colors", isOpen && "border-gray-400", selectedLabel && "border-primary-500 bg-gray-0", disabled && "cursor-not-allowed border-gray-50 bg-white", className),
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: selectedLabel ? "subtitle2" : "body2",
                        className: cn("text-primary whitespace-nowrap", selectedLabel && "text-primary-500", disabled && "text-gray-200", isOpen && selectedLabel && "text-primary-main"),
                        children: displayLabel
                    }),
                    /*#__PURE__*/ _jsx(Icon.ArrowDown_2px, {
                        className: cn("size-3.5 text-gray-400 transition-transform", selectedLabel && "text-primary", disabled && "text-gray-200", isOpen && "rotate-180 text-gray-900")
                    })
                ]
            }),
            isOpen && options.length > 0 && /*#__PURE__*/ _jsxs("div", {
                className: "relative",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "fixed inset-0 z-[899] max-sm:hidden",
                        onClick: onClose
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "absolute top-full left-0 z-[900] pt-1.5",
                        children: /*#__PURE__*/ _jsx(DropdownMenu, {
                            options: options,
                            selectedIndex: selectedIndex,
                            onSelect: handleSelect
                        })
                    })
                ]
            })
        ]
    });
});
IpSelectFilter.displayName = "IpSelectFilter";
const DropdownMenu = /*#__PURE__*/ memo((param)=>{
    let { options , selectedIndex , onSelect  } = param;
    return /*#__PURE__*/ _jsx("ul", {
        className: "min-w-[180px] max-h-[300px] overflow-y-auto py-2 bg-white border border-gray-100 rounded-md shadow-sm",
        children: options.map((option, index)=>/*#__PURE__*/ _jsx("li", {
                children: /*#__PURE__*/ _jsx("button", {
                    type: "button",
                    className: cn("w-full px-4 py-2 text-left hover:bg-gray-50 transition-colors", selectedIndex === index && "bg-indigo-0 text-primary-main"),
                    onClick: ()=>onSelect(index),
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        className: cn("text-primary", selectedIndex === index && "text-primary-500"),
                        children: option.label
                    })
                })
            }, "".concat(option.label, "-").concat(index)))
    });
});
DropdownMenu.displayName = "DropdownMenu";
export default IpSelectFilter;
